import { useLazyQuery } from '@apollo/client/react';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

import { GetDirectVisitorsDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';
import { usePreviousValue } from '~/hooks/use-previous-value';
import { newPatientDrawerState } from '~/state/patient/atoms';

export const useFetchDirectVisitors = () => {
  const [{ inputValue, page, perPage }, setState] = useAtom(newPatientDrawerState);

  const [getDirectVisitors, { called, loading, data }] = useLazyQuery(GetDirectVisitorsDocument, {
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-and-network',
  });
  const prevData = usePreviousValue(data);
  const currentData = data || prevData;
  const directVisitors = currentData
    ? (getMe(currentData)?.organization.directVisitors.nodes ?? [])
    : [];

  useEffect(() => {
    if (!data) return;
    const totalPage = getMe(data)?.organization.directVisitors.pagesCount ?? 1;
    setState((_state) => ({ ..._state, totalPage }));
  }, [data, setState]);

  useEffect(() => {
    if (inputValue?.mobilePhone)
      getDirectVisitors({
        variables: {
          page,
          perPage,
          phoneNumber: inputValue?.mobilePhone ?? null,
        },
      });
  }, [getDirectVisitors, inputValue?.mobilePhone, page, perPage]);

  return {
    loading: !called || loading,
    directVisitors,
  };
};
